export enum SolicitorTypeEnum {
  hdb_solicitor = 'hdb_solicitor',
  private_solicitor = 'private_solicitor',
  conveyancing_private_solicitor = 'conveyancing_private_solicitor',
  conveyancing_hdb_solicitor = 'conveyancing_hdb_solicitor',
}
